import { cn } from "@/lib/utils";

export function SkeletonV2({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "v2-skeleton-surface animate-pulse rounded-[var(--v2-radius-md)]",
        className
      )}
    />
  );
}
